<template>
  <el-dialog :title="isEdit?'编辑客户':'添加客户'"
             :visible.sync="visible"
             @open="init"
             @close="doClose"
             :append-to-body="true"
             :destroy-on-close="true"
             :modal-append-to-body="true"
             :close-on-click-modal="false"
             width="500px">
    <el-form class="widget-form" :model="info" label-width="80px" size="medium" ref="infoFm">
      <el-form-item prop="name" label="客户名称" :rules="[{ required: true, message: '请输入客户名称', trigger: 'blur' }]">
        <el-input type="text" v-model="info.name" placeholder="请输入客户名称"></el-input>
      </el-form-item>
      <el-form-item prop="contact" label="联系人" :rules="[{ required: true, message: '请输入联系人', trigger: 'blur' }]">
        <el-input type="text" v-model="info.contact" placeholder="请输入联系人"></el-input>
      </el-form-item>
      <el-form-item prop="phone" label="联系电话" :rules="[{ required: true, message: '请输入联系电话', trigger: 'blur' }]">
        <el-input type="number" v-model="info.phone" placeholder="请输入联系电话"></el-input>
      </el-form-item>
      <el-form-item prop="address" label="地址" :rules="[{ required: true, message: '地址', trigger: 'blur' }]">
        <el-input type="text" v-model="info.address" placeholder="请输入地址"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button @click="doClose" size="small"><i class="fa fa-close"></i> 关闭</el-button>
      <el-button type="primary" @click="submit()" size="small"><i class="fa fa-save"></i> 确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import { get, update,save } from "@/api/enterprise/customer";

export default {
  computed: {
    ...mapGetters(["user", "company"]),
    isEdit() {
      return this.id;
    }
  },
  props: {
    visible: false,
    id: null
  },
  data: function() {
    return {
      info: {}
    };
  },
  methods: {
    init() {
      if (this.isEdit) {
        this.getInfo();
      } else {
        this.info = {};
      }
    },
    getInfo() {
      get(this.id).then(res => {
        this.info = res.data.result;
      });
    },
    doClose() {
      this.$emit("done", false);
    },
    submit() {
      this.$refs["infoFm"].validate(valid => {
        if (valid) {
          if (this.isEdit) {
            update(this.info).then(res => {
              this.$message.success("保存成功");
              this.$emit("done", true);
            });
          } else {
            this.info.companyId = this.company.id
            save(this.info).then(res => {
              this.$message.success("保存成功");
              this.$emit("done", true);
            });
          }
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.sign {
  font-weight: bold;

  &:before {
    content: ' ';
    border-right: 4px solid #4381e6;
    margin-right: 8px;
  }
}
</style>
